import React from 'react';
import CompanyDetails from './CompanyDetails';
import Icon from './Icon';
import { industryLabel } from './utils';
import './CompanyDetailPanel.css';

const CompanyDetailPanel = ({ company, isOpen, onClose, onShowPeople, dataVersion = 0, onDataChanged }) => {
  const companyId = company?.companyData?.id;
  const [industry, setIndustry] = React.useState(null);

  React.useEffect(() => {
    setIndustry(null);
  }, [companyId]);

  React.useEffect(() => {
    if (!isOpen) return undefined;
    const handleEscape = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen || !company) return null;

  // Target-list nodes are named as on the list; the panel is about the company itself
  const name = company.companyData?.company_name || company.name || company.companyData?.name || company.id;
  const openFullPage = () => {
    window.open(`${window.location.origin}/?company=${companyId}`, '_blank', 'noopener,noreferrer');
  };

  return (
    <aside className={`company-detail-panel ${isOpen ? 'open' : ''}`} aria-labelledby="company-panel-title">
      <div className="company-panel-header">
        <div className="company-panel-title">
          <h2 id="company-panel-title">{name}</h2>
          <div className="company-panel-header__actions">
            {companyId && (
              <button
                type="button"
                className="company-panel-close"
                onClick={openFullPage}
                aria-label="Open in a new tab"
                title="Open in a new tab"
              >
                <Icon name="external-link" />
              </button>
            )}
            <button type="button" className="company-panel-close" onClick={onClose} aria-label="Close panel">
              <Icon name="x" />
            </button>
          </div>
        </div>
        {industry && (
          <div className="company-panel-subtext">{industryLabel(industry)}</div>
        )}
      </div>

      <div className="company-panel-content">
        <CompanyDetails
          companyId={companyId}
          name={name}
          onShowPeople={onShowPeople ? () => onShowPeople(company) : undefined}
          dataVersion={dataVersion}
          onDataChanged={onDataChanged}
          onHeaderInfo={(info) => setIndustry(info.industry)}
        />
      </div>
    </aside>
  );
};

export default CompanyDetailPanel;
